import { totalStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsTotal";
import { GridItemStyle } from "@insite/mobius/GridItem";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { colorPalette, fontFamilyAlt, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

totalStyles.orderTotal = {
    ...totalStyles.orderTotal,
    container: {
        css: css`
            display: flex;
            justify-content: flex-end;

            & > div {
                padding: 20px 10px;
                background: ${colorPalette.common.global.fadedTaupe};
                border: 1px solid ${colorPalette.common.global.industrialTaupe};
                max-width: 355px;
                margin: 35px 0 0 40px;
                width: 100%;

                div {
                    padding: 0;
                    align-items: center;
                }

                span {
                    color: ${colorPalette.common.global.darkerGray};
                    font-family: ${fontFamilyAlt};
                    font-size: 18px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.61;
                    letter-spacing: normal;
                }

                @media print {
                    width: 90% !important;
                    max-width: none;
                    margin-left: 0;
                }
            }

            ${mediaQueriesBP.maxLG} {
                &&& {
                    & > div {
                        margin: -15px 0 40px;
                        width: 100%;
                        max-width: 100%;
                    }
                }
            }

            ${mediaQueriesBP.maxMD} {
                &&& {
                    & > div {
                        margin: 40px 0;
                        width: 100%;
                        max-width: 100%;
                    }
                }
            }

            ${GridItemStyle} {
                ${TypographyStyle} {
                    @media print {
                        font-size: 14px;
                    }
                }
            }
        `,
    },
    totalLabel: {
        mergeCss: true,
        css: css`
            &&& {
                color: ${colorPalette.common.global.secondaryGray};
                font-family: ${fontFamilyAlt};
                font-size: 18px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.61;
                letter-spacing: normal;
            }
        `,
    },
    totalValueGridItem: {
        css: css`
            justify-content: flex-end;
        `,
    },
    totalValue: {
        mergeCss: true,
        css: css`
            &&& {
                color: ${colorPalette.common.global.secondaryGray};
                font-family: ${fontFamilyAlt};
                font-size: 21px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.61;
                letter-spacing: normal;

                @media print {
                    display: block;
                    text-align: right;
                }
            }
        `,
    },
};
